import React from 'react'
import AutoComplete from 'material-ui/AutoComplete'
import MenuItem from 'material-ui/MenuItem'
import ArrowIcon from 'Assets/Images/icons/arrow'

/**
 * @param {{className, hasPrimaryText, primaryText, options}} props
 */
export const AutoCompleteUnstyled = props => {
  const dataSource = props.options.map(option => ({
    text: option.label,
    value: <MenuItem primaryText={option.label} />,
  }))

  const handleBlur = element => {
    handleNewRequest(element.target.value)
  }

  const handleNewRequest = chosen => {
    const term = chosen.text || chosen
    const option = props.options.find(o => o.label === term) || {}
    props.onChange(option.value)
  }

  return (
    <div className={`${props.className} form-select`}>
      <AutoComplete
        filter={AutoComplete.fuzzyFilter}
        openOnFocus={true}
        onBlur={handleBlur}
        onNewRequest={handleNewRequest}
        dataSource={dataSource}
        id={props.id}
        name={props.name}
        placeholder={props.placeholder}
        menuStyle={{ maxHeight: '300px' }}
      />
      <ArrowIcon />
    </div>
  )
}
